import { CircleX, Delete } from 'lucide-react';

const KEYS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', 'clear', '0', 'backspace'];
const ACTIONS = {
    clear: { label: 'Clear all digits', icon: <CircleX size={22} strokeWidth={1.8} aria-hidden="true" /> },
    backspace: { label: 'Backspace', icon: <Delete size={22} strokeWidth={1.8} aria-hidden="true" /> }
};

export default function OtpKeypad({ value, onKeyPress, disabled = false, maxLength = 6, selectionLength = 0 }) {
    return (
        <div className="otp-keypad" role="group" aria-label="PIN keypad">
            {KEYS.map((key) => {
                const action = ACTIONS[key];
                const isUnavailable = action ? value.length === 0 : value.length >= maxLength && selectionLength === 0;
                return (
                    <button
                        key={key}
                        type="button"
                        aria-label={action?.label || key}
                        title={action?.label}
                        disabled={disabled || isUnavailable}
                        onMouseDown={(event) => event.preventDefault()}
                        onClick={() => onKeyPress(key)}
                    >
                        {action?.icon || key}
                    </button>
                );
            })}
        </div>
    );
}